<template>
  <button
      class="btn"
      :class="btnClass"
      type="button"
      :style="btnStyle"
      :disabled="disabled"
      @click="$emit('click', $event)"
  >
    <span class="btn__label">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    color: { type: String, default: '#1F2937' },
    text:  { type: String, default: 'Далее' },
    outlined: { type: Boolean, default: false },
    borderColor: { type: String, default: '#111827' },
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'large' },
  },
  emits: ['click'],
  computed: {
    onColor() {
      const hex = (this.color || '').replace('#','').trim();
      const c = hex.length === 3 ? hex.split('').map(x=>x+x).join('') : hex;
      const n = parseInt(c || '000000', 16);
      const r = (n>>16)&255, g = (n>>8)&255, b = n&255;
      const lum = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
      return lum > 0.6 ? '#0B1020' : '#FFFFFF';
    },
    btnStyle() {
      if (this.outlined) {
        return {
          background: '#FFFFFF',
          color: this.borderColor || '#111827',
          border: `1px solid ${this.borderColor || '#111827'}`,
        };
      }
      return { background: this.color, color: this.onColor };
    },
    btnClass() {
      return {
        'btn--sm': this.size === 'small',
      };
    }
  }
};
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 160px;
  height: 56px;
  padding: 0 24px;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  transition: transform .08s ease, box-shadow .2s ease, opacity .2s ease;
}
.btn:hover { box-shadow: 0 4px 12px rgba(0,0,0,.12); }
.btn:active { transform: translateY(1px) scale(0.99); }
.btn:focus-visible { outline: 2px solid rgba(0,0,0,.2); outline-offset: 2px; }
.btn__label { white-space: nowrap; }

.btn--sm {
  min-width: 40px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
</style>
